import React from 'react';
import './Splash.css';

const publicUrl = process.env.PUBLIC_URL;

const Splash: React.FC = () => {
	return (
		<div className='da-splash'>
			<img src={`${publicUrl}/seisma_swirl_yellow.png`} alt='DataAddiction' />
		</div>
	);
}

export default Splash;